<template>
    <button
        :type="type"
        role="button"
        :disabled="disabled"
        :aria-label="label||false"
        v-on="$listeners"
        :class="{ [`uk-button-${flavor}`]: true, [`uk-button-${color}`]: true, [`uk-button-${size}`]: true, 'uk-width-1-1': block, 'uk-active': active, waiting }"
        class="uk-button"
    >
        <loader v-if="waiting" :color="loader_color" size="sm" />
        <span :class="{ 'uk-invisible': waiting }"><slot></slot></span>
    </button>
</template>

<script>
import Loader from "./Loader"

export default {
    name: "DefaultButton",
    components: {
        Loader
    },
    computed: {
        loader_color () {
            if(this.color === "primary") return "light"
            if((this.color === "secondary") || (this.color === "lam-orange") || (this.color === "regular")) return "primary"
            return "gray"
        }
    },
    props: {
        label: {
            type: String,
            validator: prop => !!prop
        },
        type: {
            type: String,
            default: "button"
        },
        flavor: {
            type: String,
            validator: prop => !prop || prop.match(/^(link|normal)$/i),
            default: "normal"
        },
        color: {
            type: String,
            validator: prop => !prop || prop.match(/^(primary|secondary|lam-orange|regular|success|danger|white)$/i),
            default: "regular"
        },
        size: {
            type: String,
            validator: prop => !prop || prop.match(/^(mini|small|medium|large)$/i),
            default: "medium"
        },
        block: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        waiting: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="less">
@import "@/assets/less/variables";

button.uk-button {
    position: relative;

    .lam-loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &.lam-admin-toggle {
        position: fixed;
        right: 5px;
        bottom: 15px;
        padding: 0;
        opacity: 0.5;
        transition: all 0.3s ease;

        &:hover,
        &.uk-active {
            opacity: 1;
        }
        &.uk-active {
            background-color: @global-success-background;
            color: white;

            &:hover {
                background-color: @global-success-hover-background;
            }
        }
    }
}
</style>
